import TransLogTabs from "../components/TransLogTabs";
import TransLogTables from "../components/TransLogTables";
import { toRefs } from "vue";
export default {
  name: "Downloading",
  components: {
    TransLogTabs,
    TransLogTables
  },
  setup() {
    const data = {
      columns: [{
        label: '文件名称',
        prop: 'fileName'
      }, {
        label: '需求名称',
        prop: 'demandName'
      }, {
        label: '文件大小',
        prop: 'handleSize'
      }],
      startBtn: '暂停',
      cancelBtn: '取消',
      actionType: '2',
      uploadBtn: '继续下载'
    };
    return {
      ...toRefs(data)
    };
  }
};